import {
  AccountData,
  SavedFormResponse,
  SavedFormQuestion,
} from "@markit/common.types";
import { useCallback, useState } from "react";
import { MassTextsPersonItem } from "../../CreatorDashboard/MassTexts/Items/MassTextsPersonItem";
import SingleCustomData from "../../FollowerProfile/SingleCustomData";

type SavedResponseProfileItemProps = {
  user: AccountData;
  savedQuestion: SavedFormQuestion;
  formResponse: SavedFormResponse | undefined;
  setProfileSelected: (profileSelected: AccountData) => void;
  unsavedRecipients: string[];
  setUnsavedRecipients: (unsavedRecipients: string[]) => void;
  excludingMode: boolean;
  disableCheck: boolean;
  subtext?: JSX.Element;
  removeDivider?: boolean;
};

// Wrapper around a profile related item to show the full saved form response details modal
const SavedResponseProfileItem = ({
  user,
  setProfileSelected,
  savedQuestion,
  formResponse,
  unsavedRecipients,
  setUnsavedRecipients,
  excludingMode,
  disableCheck,
  subtext,
  removeDivider,
}: SavedResponseProfileItemProps) => {
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [localFormResponse, setLocalFormResponse] = useState<
    SavedFormResponse | undefined
  >(formResponse);

  const onPress = useCallback(() => {
    setShowDetailsModal(true);
  }, []);

  return (
    <div>
      <MassTextsPersonItem
        user={user}
        setProfileSelected={setProfileSelected}
        unsavedPeople={unsavedRecipients}
        setUnsavedPeople={setUnsavedRecipients}
        excludingMode={excludingMode}
        disableCheck={disableCheck}
        subtext={subtext}
        alternateOnPress={disableCheck ? onPress : undefined}
        removeDivider={removeDivider}
      />
      {showDetailsModal ? (
        <SingleCustomData
          savedQuestion={savedQuestion}
          formResponse={localFormResponse}
          setFormResponse={setLocalFormResponse}
          userData={user}
          followerData={undefined}
          closeSingleCustomData={() => setShowDetailsModal(false)}
        />
      ) : null}
    </div>
  );
};

export default SavedResponseProfileItem;
